import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Currency } from '../../../common/currency';
import arrow from '../../../images/newDesign/arrow_down.svg';
import BllinkUtils from '../../../common/utils/utils';
import { StyledBalanceRecord } from './BalanceReport.styled';

const StringUtils = BllinkUtils.Strings;
const Money = BllinkUtils.Money;

const BalanceReportCard = ({ ltr, total, currency, charged, needed, expenseKey, expense, methods = [], year}) => {
    const { t } = useTranslation();

    const [showTotalIncomeRow, setShowTotalIncomeRow] = useState(false);

    const openCloseCard = () => setShowTotalIncomeRow(!showTotalIncomeRow);

    const roundValues = value => {
        const rounded = Money.roundNumber(value, 2);
        return StringUtils.numberWithCommas(rounded);
    };

    return (
        <StyledBalanceRecord ltr={ltr} showTotalIncomeRow={showTotalIncomeRow}>
            {total && <div className='open-close-btn' onClick={openCloseCard}><img src={arrow} /></div>}
            <>
                <div className='wrapper'>
                    <span className={total ? 'total-highlited' : ''}>{total ? (expense ? t('reports.balance_total') : t('reports.balance_income')) : t(`expenses.expenseTypes.${expenseKey}`, {year})}</span>
                    <span>{expense ? `(${roundValues(needed)})` : roundValues(needed)} <Currency>{currency}</Currency></span>
                    <span className='total-highlited'>{expense ? `(${roundValues(charged)})` : roundValues(charged)} <Currency>{currency}</Currency></span>
                    <span>{expense ? `(${roundValues(needed - charged)})` : roundValues(needed - charged)} <Currency>{currency}</Currency></span>
                </div>
                {
                    showTotalIncomeRow && (
                        <div className='total-opened-info'>
                            {methods?.map((record) => {
                                return (
                                    <div className='wrapper'>
                                        <span>{t(`reports.${record.paymentMethod}`)}</span>
                                        <span>{roundValues(record.paid)} <Currency>{currency}</Currency></span>
                                    </div>
                                );
                            })}
                        </div>
                    )
                }
            </>
        </StyledBalanceRecord>
    )
}

export default BalanceReportCard;
